<template>
  <div>
    <div class="payment-complete">
      <div class="overlay">
        &nbsp;
      </div>
      <div class="outer">
        <div class="inner">
          <div class="title">
            <h3>Payment Completed</h3>
          </div>
          <div class="receipt-details">
            <div class="receipt-no">
              <strong>Receipt No:</strong> {{ receiptNo }}
            </div>
            <div class="payment-date">
              <strong>Payment Date:</strong> {{ paymentDate }}
            </div>
            <div class="payment-amount">
              <strong>Total Payment:</strong> $ {{ paymentAmount }}
            </div>
            <hr>
            <div class="inv-no">
              <strong>Inv No:</strong> {{ txnid }}
            </div>
            <div class="inv-date">
              <strong>Inv Date:</strong> {{ txnDate }}
            </div>
            <div class="inv-amount">
              <strong>Invoice Amount:</strong> $ {{ invoiceAmount }}
            </div>
            <div>
              <a href="javascript:window.history.back()">Go Back</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'payment-complete',
  props: {
    receipt: {
      type: Object,
      required: true
    }
  },
  computed: {
    txnid: function() {
      return this.receipt.transaction.txnid
    },
    receiptNo: function() {
      return this.receipt.receiptno
    },
    paymentDate: function() {
      return dayjs(this.receipt.payment_date).format('ddd, D MMM YYYY - hh:mm a')
    },
    txnDate: function() {
      return dayjs(this.receipt.transaction.txndate).format('ddd, D MMM YYYY - hh:mm a')
    },
    paymentAmount: function() {
      return parseFloat(this.receipt.paymentamount).toFixed(2)
    },
    invoiceAmount: function() {
      return parseFloat(this.receipt.transaction.invTotal).toFixed(2)
    }

  }
}
</script>

<style lang='scss' scoped>

  .payment-complete .outer {
    position: relative;
    z-index: 15;
    margin: 0 auto;
    max-width:80%;
  }
  .payment-complete .inner {
    position: absolute;
    background-color: #fff;
    top: 0;
    padding: 2em;
    z-index: 20;
    text-align: center;
    width: 80%;
    border-radius: 3px;
    margin: 2em auto;
    left: 0;
    right: 0;
    box-shadow: 0px 1px 10px 0px #00000040;
  }

  .payment-complete .overlay {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: .4;
    z-index: 10;
    background-color: #EEE;
  }

</style>
